import {
  createMapper,
  getValueFromObj,
} from "../../../../../../../../utils/utils";

const MEDICATION_DOSAGE_LIST = [
  { value: "mg", label: "Mg" },
  { value: "tablet", label: "Tablet (s)" },
  { value: "g", label: "g" },
  { value: "mcg", label: "Mcg" },
  { value: "mL", label: "mL" },
  { value: "unit", label: "Unit" },
  { value: "IU", label: "IU" },
  { value: "mL per hour", label: "mL Per Hour" },
  { value: "mg per kg", label: "Mg Per Kg" },
  { value: "puffs", label: "Puffs" },
  { value: "drops", label: "Drops" },
  { value: "sprays", label: "Sprays" },
  { value: "capsule", label: "Capsule" },
  { value: "teaspoon", label: "Teaspoon" },
  { value: "tablespoon", label: "Tablespoon" },
  { value: "mEq", label: "mEq" },
  { value: "%", label: "%" },
  { value: "mg/mL", label: "Mg/mL" },
];

const MEDICATION_ROUTE_LIST = [
  { value: "Oral", label: "Oral" },
  { value: "Topical", label: "Topical" },
  { value: "Subcutaneous", label: "Subcutaneous" },
  { value: "Intramuscular", label: "Intramuscular" },
  { value: "Intravenous", label: "Intravenous" },
  { value: "Inhalation", label: "Inhalation" },
  { value: "Transdermal", label: "Transdermal" },
  { value: "Nasal", label: "Nasal" },
  { value: "Sublingual", label: "Sublingual" },
  { value: "Rectal", label: "Rectal" },
  { value: "Vaginal", label: "Vaginal" },
  { value: "Optic", label: "Optic" },
];

export const MEDICATION_ROUTE_LIST_MAPPER = createMapper(MEDICATION_ROUTE_LIST);
export const MEDICATION_DOSAGE_LIST_MAPPER = createMapper(
  MEDICATION_DOSAGE_LIST
);

const VACCINE_ROUTE_LIST = [
  { value: "BUCCEL", label: "Buccel" },
  { value: "DENTAL", label: "Dental" },
  { value: "EPIDURAL", label: "Epidural" },
  { value: "INJECTION", label: "Injection" },
];

export const VACCINE_ROUTE_MAPPER = createMapper(VACCINE_ROUTE_LIST);

export const VACCINE_SITE_LIST = [
  { value: "ANKLE_LEFT", label: "Ankle Left" },
  { value: "ANKLE_RIGHT", label: "Ankle Right" },
  { value: "BLADDER", label: "Bladder" },
  { value: "ARM_LEFT_UPPER", label: "Arm Left Upper" },
];

export const VACCINE_SITE_MAPPER = createMapper(VACCINE_SITE_LIST);

export const CLINICAL_DETAILS_TABS_DATA = [
  {
    value: "",
    label: "Allergies",
  },
  {
    value: "diagnosis",
    label: "Diagnosis",
  },
  {
    value: "medications",
    label: "Medications",
  },
  {
    value: "vaccines",
    label: "Vaccines",
  },
  {
    value: "vitals",
    label: "Vitals",
  },
  {
    value: "care_plan",
    label: "Care Plan",
  },
];

export const convertFamilyHistoryPrefillPayload = (row: any) => {
  const problems = row?.problems
    ? {
        name: getValueFromObj(row?.problems),
        uuid: Object.keys(row?.problems)?.[0],
      }
    : undefined;

  const relative = row?.relative ?? undefined;

  return { ...row, problems, relative };
};

const RELATIVE_ENUM_MAPPER: Record<any, string> = {
  Self: "SELF",
  Spouse: "SPOUSE",
  Other: "OTHER",
  Child: "CHILD",
  Employer: "EMPLOYER",
  Father: "FATHER",
  Mother: "MOTHER",
  Parent: "PARENT",
  Grandparent: "GRANDPARENT",
  Sibling: "SIBLING",
  Unknown: "UNKNOWN",
  Grandchild: "GRANDCHILD",
  Guardian: "GUARDIAN",
};

export const RELATIVE_LABEL_MAPPER: Record<string, string> = Object.fromEntries(
  Object.entries(RELATIVE_ENUM_MAPPER).map(([label, value]) => [value, label])
);
